import { render, staticRenderFns } from "./BottomDialog.vue?vue&type=template&id=6dc7d772"
import script from "./BottomDialog.vue?vue&type=script&lang=ts"
export * from "./BottomDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports